import { Dialog as MuiDialog, DialogProps as MuiDialogProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type DialogCloseReason = 'backdropClick' | 'escapeKeyDown' | 'closeButton';

export type DialogOnClose = (event: object, reason: DialogCloseReason) => void;

export interface DialogProps extends Omit<MuiDialogProps, 'onClose'> {
  onClose?: (event: object, reason: DialogCloseReason) => void;
}

const StyledDialog = styled(MuiDialog)<MuiDialogProps>(() => ({
  '& .MuiDialog-paper': {
    borderRadius: '16px',
    paddingTop: '16px',
    paddingBottom: '16px',
  },
}));

export function Dialog({ children, onClose, ...props }: DialogProps) {
  return (
    <StyledDialog onClose={onClose} {...props}>
      {children}
    </StyledDialog>
  );
}
